const BACKOFFICE_HOME_PATH = '/nexus';
const BACKOFFICE_LOGIN_PATH = '/login';

export function redirectToBackofficeHome(): void {
  window.location.href = BACKOFFICE_HOME_PATH;
}

export function redirectToBackofficeLogin(): void {
  window.location.href = BACKOFFICE_LOGIN_PATH;
}
